export class AppSettings {
   
  }